import React from 'react';
import { COLORS } from '../../config/colors';

const CurvyDivider = ({ fromColor = "white", toColor = "pink-50", flip = false }) => {
  const getTailwindColor = (color) => {
    const colorMap = COLORS;
    const cleanColor = color.replace('bg-', '');
    return colorMap[cleanColor] || color;
  };

  return (
    <div className="w-full relative z-10 -mb-16">
      <svg
        className={`w-full h-32 ${flip ? 'transform rotate-180' : ''}`}
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
        style={{
          fill: getTailwindColor(toColor),
          backgroundColor: getTailwindColor(fromColor)
        }}
      >
        <path d="M0,0 C300,80 900,80 1200,0 L1200,120 L0,120 Z" />
      </svg>
    </div>
  );
};

export default CurvyDivider; 